import { useStore } from 'dg-web-shared/lib/Flux';
import * as LayoutState from '../state/LayoutState';
import { columnsVariant } from '../utils/columnsVariant';
import { columnsContainer } from '../utils/columnsContainer';
import { css } from '@emotion/css';

export interface LayoutContainerProps {
    children?: React.ReactNode;
    layoutVariant: LayoutVariantOption;
}
export interface LayoutContainerState {
    layout: LayoutState.State;
}

export enum LayoutVariantOption {
    Application,
    StaticPage,
}

export function LayoutContainer({
    children,
    layoutVariant,
}: LayoutContainerProps) {
    const { storeState } = useStore(store => ({
        layout: new LayoutState.StateSlice(store).state,
    }));

    return (
        <div
            className={css([
                {
                    margin: 'auto',
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },
                columnsVariant(storeState) === 'OneColumn' && {
                    overflowX: 'hidden',
                    overFlowY: 'auto',
                    WebkitOverflowScrolling: 'touch',
                },
            ])}
            style={{
                width: columnsContainer.width(storeState, layoutVariant),
            }}
        >
            {children}
        </div>
    );
}
